// Decorative snippets rained down the home section by CodeRain.
export const codeSnippets = [
  // HTML
  "<div class='container'></div>",
  "<h1>Welcome to My Site</h1>",
  "<a href='#'>Click Here</a>",
  "<ul><li>Item 1</li>",
  "<p>This is a paragraph.</p>",

  // CSS
  ".container { width:",
  "body { color: white;",
  "text-align: center;",
  ".btn { padding: 10px",
  "a:hover { text-deco",

  // JavaScript
  "const x = 10;",
  "let name = 'John';",
  "if (a > b) {}",
  "{ return a + b; }",
  "const arr = [1, 2, 3];",
  "console.log('Hello');",
  "getElementById('id');",
  "async function fetchData",
  "const sum = (a, b)",
  "{ name: 'Alice' };",

  // Python
  "x = 10",
  "return f'Hello W",
  "if x > 5",
  "import math",
  "list = [1, 2, 3]",
  "with open('file",
  "def add(a, b)",
  "try: pass except",
  "class Person: pass",
  "print('Python Code!')",

  // PHP
  "$x = 10;",
  "$name = 'John';",
  "if ($x > 5)",
  "function greet($name)",
  "$arr = [1, 2, 3];",
  "$conn = new mysqli",
  "echo 'Hello, World!'",
  "try { } catch",
  "json_decode",
  "include('header.php');",

  // MySQL
  "SELECT *",
  "INSERT",
  "WHERE id = 1;",
  "FROM users",
  "SELECT name",
  "CREATE",
  "VARCHAR(100);",
  "COUNT(*)",
  "DROP TABLE",
  "DESCRIBE users;",
];
